module.exports = __webpack_public_path__ + "img/male-infant-head.4b8b07db.svg";